module.exports = __webpack_public_path__ + "e6eba8e55458ed8b872f6ca7258fae6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/bigprice.png
// module id = 281
// module chunks = 0